import { motion } from "framer-motion";
import { CalendarDays, ArrowRight } from "lucide-react";
import { FadeUp } from "./Reveal";

export default function GiveawayTeaser() {
  return (
    <section
      data-testid="giveaway-teaser"
      className="mx-auto max-w-7xl px-6 pt-20 lg:px-10"
    >
      <FadeUp>
        <a
          href="/community"
          data-testid="giveaway-teaser-cta"
          className="group flex flex-col items-center gap-8 rounded-[2rem] border border-[#C85C40]/25 bg-[#C85C40]/[0.07] p-8 transition-[background-color,border-color,transform] duration-500 hover:-translate-y-1 hover:border-[#C85C40]/50 hover:bg-[#C85C40]/[0.12] sm:flex-row sm:gap-10 sm:p-10"
        >
          <motion.img
            src="/assets/turkey-flyer.jpg"
            alt="Thanksgiving Turkey Basket Giveaway flyer"
            whileHover={{ rotate: 0, scale: 1.03 }}
            className="h-44 w-auto -rotate-2 rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.12)] transition-transform duration-500"
            data-testid="giveaway-teaser-flyer"
          />
          <div className="text-center sm:text-left">
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#C85C40]">
              Community Event
            </p>
            <h2 className="mt-2 font-serif text-3xl leading-tight tracking-tight sm:text-4xl">
              Thanksgiving{" "}
              <span className="italic text-[#C85C40]">Turkey Basket</span>{" "}
              Giveaway
            </h2>
            <p className="mt-3 flex flex-wrap items-center justify-center gap-2 text-sm font-semibold text-[#5C5C5A] sm:justify-start">
              <CalendarDays className="h-4 w-4 text-[#C85C40]" />
              Wednesday, November 25, 2026 · 10:00 AM · at our laundromat
            </p>
            <p className="mt-2 text-sm text-[#5C5C5A]">
              Free turkey baskets for our neighbors, with Sankofa Youth and
              Family Services, Inc.
            </p>
          </div>
          <span className="inline-flex shrink-0 items-center gap-2 rounded-full bg-[#C85C40] px-7 py-3.5 text-sm font-bold text-white transition-[background-color,transform] duration-300 group-hover:scale-[0.98] group-hover:bg-[#A84C34] sm:ml-auto">
            Event Details
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </span>
        </a>
      </FadeUp>
    </section>
  );
}
